export const globalColorsTheme = {
  neutral: {
    neutral100: '#FFFFFF',
    neutral200: '#F8FAFC',
    neutral300: '#F1F5F8',
    neutral400: '#E4E7EC',
    neutral500: '#C3CAD5',
    neutral600: '#8B95A9',
    neutral700: '#646F87',
    neutral800: '#475467',
    neutral900: '#344054',
    neutral1000: '#18191B',
    neutralA80: 'rgba(255, 255, 255, 0.8)',
    neutralA60: 'rgba(255, 255, 255, 0.6)',
    neutralA35: 'rgba(255, 255, 255, 0.35)'
  },
  positive: {
    positive100: '#DFF5E7',
    positive200: '#B1E2C4',
    positive300: '#9BDAB3',
    positive400: '#7DCF9D',
    positive500: '#54BF7E',
    positive600: '#41AE6C',
    positive700: '#028838',
    positive800: '#00702D',
    positive900: '#014B1F',
    positive1000: '#012811'
  },

  warning: {
    warning100: '#FFF8E6',
    warning200: '#FFF0CA',
    warning300: '#FFE9B2',
    warning400: '#FFE299',
    warning500: '#FFD875',
    warning600: '#FDC535',
    warning700: '#FDB702',
    warning800: '#E6A702',
    warning900: '#B88501',
    warning1000: '#986E01'
  },
  critical: {
    critical100: '#FDE7E9',
    critical200: '#FAC4C9',
    critical300: '#F9B4BA',
    critical400: '#F79CA4',
    critical500: '#F57F89',
    critical600: '#F14755',
    critical700: '#D80E25',
    critical800: '#C50C22',
    critical900: '#8D0411',
    critical1000: '#6D030D'
  },
  informative: {
    informative100: '#E6F4FF',
    informative200: '#C7DAFD',
    informative300: '#B5CEFC',
    informative400: '#A2C1FB',
    informative500: '#8FB4FA',
    informative600: '#5484F8',
    informative700: '#306AF7',
    informative800: '#2256D6',
    informative900: '#0351C0',
    informative1000: '#023D91'
  },
  decorative: {
    decorative1: '#FFFDD5',
    decorative2: '#C06007',
    decorative3: '#F9F0FF',
    decorative4: '#391085',
    decorative5: '#FFF0F6',
    decorative6: '#9E1068',
    decorative7: '#E6FFFB',
    decorative8: '#006D75',
    decorative9: '#FAFAFA',
    decorative10: '#434343',
    decorative11: '#E6F4FF',
    decorative12: '#003EB3'
  }
};
